import React, { useEffect, useContext } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import login from "./login";
import UserLayout from "../../Layout/UserLayout";
import useReactRouter from "use-react-router";
import { LangContext } from "../../Context/Langcontext";

const User = ({ match }) => {
  const { history, location } = useReactRouter();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  useEffect(() => {
    if (localStorage.getItem("token")) {
      history.replace("/app");
    }
  }, [history]);

  useEffect(() => {
    document.title = `${
      location.pathname === "/user/login"
        ? lang.Signin
        : location.pathname === "/user/forgot-password"
        ? lang.ForgotPassword
        : lang.Register
    } | ${lang.MEAtitle}`;
    return () => {};
  }, [location, lang]);

  return (
    <UserLayout>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/login`} />
        <Route path={`${match.url}/login`} component={login} />
        <Route path={`${match.url}/register`} component={login} />
        <Route path={`${match.url}/forgot-password`} component={login} />
        <Redirect to="/error" />
      </Switch>
    </UserLayout>
  );
};

export default User;
